import MarketingLayout from '$components/MarketingLayout';
import MailchimpSignup from '$components/MailchimpSignup';
import Hero from '$components/Hero';
import { Flex, Col } from '$components/Flex';
import MarketingSection from '$components/MarketingSection';
import MarketingDivide from '$components/MarketingDivide';
import Contributions from '$components/MarketingContributions';
import Contribution from '$components/MarketingContribution';
import chat from '$images/contributions/chat.png';
import code from '$images/contributions/code.png';
import docs from '$images/contributions/docs2.png';
import sponsor from '$images/contributions/sponsor.png';
import stories from '$images/contributions/stories.png';
import talks from '$images/contributions/talks2.png';
import write from '$images/contributions/write.png';
import React from 'react';
export default {
  MarketingLayout,
  MailchimpSignup,
  Hero,
  Flex,
  Col,
  MarketingSection,
  MarketingDivide,
  Contributions,
  Contribution,
  chat,
  code,
  docs,
  sponsor,
  stories,
  talks,
  write,
  React
};